module.exports = __webpack_public_path__ + "media/images/top/common/img_voice_result02-93a9c5d4cd5d70da505b95f7591bab44.png";